import { memo } from 'react'
import { Box, useTheme } from '@mui/material'

import mainBannerDark from 'assets/main-dark.png'
import mainBannerLight from 'assets/main-light.png'
import { Image } from '../image'
import { THEME_MODE } from '../../../constants/theme'

const MainBanner = () => {
  const theme = useTheme()
  return (
    <Box
      sx={{
        minWidth: 120,
        maxWidth: 240
      }}
    >
      <Image
        src={
          theme.palette.mode === THEME_MODE.DARK
            ? mainBannerDark
            : mainBannerLight
        }
        sx={{ aspectRatio: '1/1' }}
      />
    </Box>
  )
}

export default memo(MainBanner)
